module.exports = __webpack_public_path__ + "media/images/pages/fcr/lab-8-c94a49fc40deaed21ee36d1e4c21d000.png";